import { adaptDotNetDayOfWeekDTOToDayOfWeek } from '../../utilities/enum/dotNetDayOfWeekToDayOfWeek.adapter';
import {
  IFormBase,
  OfficeHoursDays,
  OfficeHoursFormField,
} from '@/forms/typings';
import {
  CheckboxFormFieldBuilder,
  OfficeHoursFormFieldBuilder,
  TimeFormFieldBuilder,
} from '@/forms/builders';
import { FormOfficeHoursFieldResponseDTO } from '@/api/base/DTOs';
import { adapt24hoursTimeTo12hoursTime } from '../../utilities/time/24hoursTimeTo12hoursTime.adapter';
import { config } from '@/forms/config';

export const adaptFormOfficeHoursFieldResponseToOfficeHoursFormField = (
  formOfficeHoursFieldResponse: FormOfficeHoursFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): OfficeHoursFormField => {
  const showOnCall = formOfficeHoursFieldResponse.showOnCall === true;
  const showClosed = formOfficeHoursFieldResponse.showClosed === true;

  const days = formOfficeHoursFieldResponse.days?.reduce((acc, day) => {
    const dayKey = adaptDotNetDayOfWeekDTOToDayOfWeek(day.key);

    const groupName = day.value.name;

    acc[dayKey] = {
      name: groupName,
      fields: [
        new TimeFormFieldBuilder()
          .fieldId(day.value.fromFieldID)
          .name(day.value.fromFieldID)
          .label('From')
          .value(
            day.value.valueFrom
              ? adapt24hoursTimeTo12hoursTime(day.value.valueFrom)
              : undefined,
          )
          .hasAnyValue(day.value.valueFrom !== undefined)
          .readonly(!formOfficeHoursFieldResponse.isEditable)
          .parentFieldId(formOfficeHoursFieldResponse.fieldID)
          .build(),
        new TimeFormFieldBuilder()
          .fieldId(day.value.toFieldID)
          .name(day.value.toFieldID)
          .label('To')
          .value(
            day.value.valueTo
              ? adapt24hoursTimeTo12hoursTime(day.value.valueTo)
              : undefined,
          )
          .hasAnyValue(day.value.valueTo !== undefined)
          .readonly(!formOfficeHoursFieldResponse.isEditable)
          .parentFieldId(formOfficeHoursFieldResponse.fieldID)
          .build(),
        ...(showOnCall
          ? [
              new CheckboxFormFieldBuilder()
                .fieldId(
                  `${day.value.fromFieldID}${config.officeHoursOnCallFieldSuffix}`,
                )
                .name(
                  `${day.value.fromFieldID}${config.officeHoursOnCallFieldSuffix}`,
                )
                .label('On call')
                .value(day.value.onCall ?? false)
                .hasAnyValue((day.value.onCall ?? false) === true)
                .readonly(!formOfficeHoursFieldResponse.isEditable)
                .parentFieldId(formOfficeHoursFieldResponse.fieldID)
                .build(),
            ]
          : []),
        ...(showClosed
          ? [
              new CheckboxFormFieldBuilder()
                .fieldId(day.value.closedFieldID)
                .name(day.value.closedFieldID)
                .label('Closed')
                .value(day.value.closed ?? false)
                .hasAnyValue((day.value.closed ?? false) === true)
                .readonly(!formOfficeHoursFieldResponse.isEditable)
                .parentFieldId(formOfficeHoursFieldResponse.fieldID)
                .build(),
            ]
          : []),
      ],
    };
    return acc;
  }, {} as OfficeHoursDays);

  return new OfficeHoursFormFieldBuilder()
    .fieldId(formOfficeHoursFieldResponse.fieldID)
    .name(formOfficeHoursFieldResponse.name)
    .showOnCall(formOfficeHoursFieldResponse.showOnCall)
    .showClosed(formOfficeHoursFieldResponse.showClosed)
    .days(days)
    .hasAnyValue(formOfficeHoursFieldResponse.hasAnyValue)
    .notApplicable(formOfficeHoursFieldResponse.notApplicable)
    .showNotApplicable(formOfficeHoursFieldResponse.showNotApplicable)
    .parentFieldId(parentFieldId)
    .build();
};
